<mds-dialog dialogTitle="Request History">
    <mds-dialog-content>
        <mds-table
            id="request-history"
            [dataSource]="requestStatusLog()"
            [hasCustomRowDefs]="true"
            dataWhiteSpace="nowrap"
            [noDataMessage]="
                requestStatusLog()?.data?.length > 0
                    ? 'No data found matching the filter.'
                    : 'No data available in table.'
            "
            matSort
        >
            <ng-container [matColumnDef]="columnMap[0].name">
                <mat-header-cell *matHeaderCellDef> {{ columnMap[0].header }}</mat-header-cell>
                <mat-cell *matCellDef="let element">{{ element.info }}</mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="columnMap[1].name">
                <mat-header-cell *matHeaderCellDef>{{ columnMap[1].header }}</mat-header-cell>
                <mat-cell *matCellDef="let element">{{
                    getLocalDate(element.occurredOn) | dateFormat: DateFormat.dateOnly : null | uppercase
                }}</mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="columnMap[2].name">
                <mat-header-cell *matHeaderCellDef>{{ columnMap[2].header }}</mat-header-cell>
                <mat-cell *matCellDef="let element">{{
                    element.triggeredByEmail
                        ? `${element.triggeredBy} (${element.triggeredByEmail})`
                        : element.triggeredBy
                }}</mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="columnMap[3].name">
                <mat-header-cell *matHeaderCellDef>{{ columnMap[3].header }}</mat-header-cell>
                <mat-cell *matCellDef="let element">{{ element.details }}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="requestColumns"> </mat-header-row>
            <mat-row *matRowDef="let row; columns: requestColumns"></mat-row>
        </mds-table>
    </mds-dialog-content>
    <mds-dialog-actions>
        <mds-button
            [id]="'medpaceBtn'"
            label="Close"
            (clickEvent)="closeDialog()"
            variant="outline"
            color="neutral"
        ></mds-button>
    </mds-dialog-actions>
</mds-dialog>
